import { useEffect, useState } from 'react';
import { usePubNub } from 'pubnub-react';
import { useSettings } from '../routing/RoutingMediator';

export const useIsUserOnline = (userId: string): boolean => {
  const [isUserOnline, setIsUserOnline] = useState<boolean>(false);
  const pubnub = usePubNub();
  const { site } = useSettings();

  // This exists in a few places.. tried importing it from pubnubContext but got a circular dependency error
  const systemChannel = `system-${site?.platform_id}`.slice(0, -7);

  useEffect(() => {
    const checkUserPresence = async () => {
      try {
        const result = await pubnub.hereNow({
          channels: [systemChannel],
          includeUUIDs: true,
        });

        const channelData = result.channels[systemChannel];
        if (channelData && channelData.occupants) {
          // Check if the userId exists in the list of occupants
          const isPresent = channelData.occupants.some((occupant) => occupant.uuid === userId);
          setIsUserOnline(isPresent);
        } else {
          setIsUserOnline(false);
        }
      } catch (error) {
        console.error('Error checking user presence:', error);
        setIsUserOnline(false);
      }
    };

    checkUserPresence();
  }, [pubnub, systemChannel, userId]);

  return isUserOnline;
};
